import React from "react";
import styled from "styled-components";
import { arrayOf, func, object } from "prop-types";

import Typography from "components/shared/Typography";

import { usePrimaryColor } from "@hooks/usePrimaryColor";
import { color } from "@components/shared/utils";

const Container = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

const StyledButton = styled.button`
  border: solid ${color("amiParisianis")} 3px;
  border-radius: 5px;
  cursor: pointer;
  padding: 0.25rem;
  margin: 0.5rem 0.25rem 0;

  background-color: ${({ isSelected, theme }) =>
    isSelected ? theme.colors.white : theme.colors.amiParisianis};

  &:focus {
    outline: 0;
  }

  &:disabled {
    background-color: ${color("white")};
    border: solid ${color("grey")} 3px;
    cursor: default;
  }
`;

const SlotPicker = ({ slots, onSlotChange, selectedSlot }) => {
  const primaryColor = usePrimaryColor();

  return (
    <Container primaryColor={primaryColor} data-id="slot-picker">
      {slots
        .filter(slot => slot.driversSlotsAvailable !== 0)
        .map(slot => (
          <StyledButton
            key={slot.name}
            isSelected={selectedSlot?.name === slot.name}
            onClick={() => onSlotChange(slot)}
          >
            <Typography size="xs">{slot.name.replace(/\s/g, "-")}</Typography>
          </StyledButton>
        ))}
    </Container>
  );
};

SlotPicker.propTypes = {
  slots: arrayOf(object).isRequired,
  selectedSlot: object,
  onSlotChange: func,
};

export default SlotPicker;
